<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- general tab -->
    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">General</span>
      </template>

      <account-setting-general
        :general-data="options.general"
      />
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>
      <!-- title -->
      <template #title>
        <feather-icon icon="LockIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Update password</span>
      </template>

      <account-setting-password />
    </b-tab>
    <!--/ change password tab -->

    <!-- info -->
    <!-- <b-tab>
      <template #title>
        <feather-icon icon="InfoIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Compnay informations</span>
      </template>

      <account-setting-information
        v-if="options.info"
        :information-data="options.info"
      />
    </b-tab> -->



  </b-tabs>
</template>

<script>
import { BTabs, BTab } from "bootstrap-vue";
import AccountSettingGeneral from "./AccountSettingGeneral.vue";
import AccountSettingPassword from "./AccountSettingPassword.vue";
import AccountSettingInformation from "./AccountSettingInformation.vue";

import axios from "axios";

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
  },
  data() {
    return {
      options: {},
    };
  },
  created() {
    // const res = await axios.get(
    //   `https://mtl-feeder-nodejs.onrender.com/api/users?id=${
    //     JSON.parse(localStorage.getItem("userData"))._id
    //   }`
    // );
    // if(!res){
    var res=JSON.parse(localStorage.getItem("userData"))
    // }
    this.options = {
      general: {
        firstName: res.admin.firstName,
        lastName: res.admin.lastName,
        email: res.email,
        // image:
        //   res.data.image != null
        //     ? `https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/${res.data.image}`
        //     : "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fstatic.vecteezy.com%2Fsystem%2Fresources%2Fpreviews%2F000%2F439%2F863%2Foriginal%2Fvector-users-icon.jpg&f=1&nofb=1",
      },
      // info: {
      //   paymentTerms: res.data.paymentTerms,
      //   companyEmail: res.data.companyEmail,
      //   companyFax: res.data.companyFax,
      //   companyTel: res.data.companyTel,
      //   currency: res.data.currency,
      //   taxRegistrationNumber: res.data.taxRegistrationNumber,
      //   paymentType: res.data.paymentType,
      //   country: res.data.country,
      //   postalCode: res.data.postalCode,
      //   address: res.data.address,
      //   company: res.data.company,
      //   signature: res.data.signature
      // },
    };

  },
};
</script>
